import { SwitchHistorical } from '../../../../../shared/types/modules/switch';

export interface SwitchHistoricalProps {
    historical: SwitchHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    createdAt: 'Fecha de creación',
    name: 'Nombre',
    product: 'Producto',
    typePqr: 'Tipo Pqr',
    motive: 'Motivo',
    submotive1: 'Submotivo 1',
    submotive2: 'Submotivo 2',
    submotive3: 'Submotivo 3',
    submotive4: 'Submotivo 4',
    category: 'Categoria',
    process: 'Proceso',
    subprocess: 'Subproceso',
    riskId: 'NO. Riesgo',
    risk: 'Riesgo',
    consequence: 'Consecuencia',
    riskImpact: 'Impacto del riesgo',
    sfcMotiveClaim: 'Motivo de reclamación SFC',
    sfcSubaccount: 'Subcuenta SFC',
    sfcMotive: 'Motivo [SECTOR - FASECOLDA]',
    sfcSubmotive: 'Submotivo [SECTOR - FASECOLDA]',
    sfcMotiveIdComplaint: 'Código motivo quejas sector SFC(Nuevo)',
    sfcMotiveIdComplaintOld: 'Código motivo quejas sector SFC(Anterior)',
    typeComplaint: 'Tipo de queja',
    motiveName: 'Nombre Motivo de Queja SFC',
    motiveDescription: 'Descripción Motivo de Quejas SFC',
    active: 'Estado',
};
